import { mapGetters } from "vuex";

import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import ConfiguracaoFranquiaModel from "@/models/configuracaoFranquia/configuracaoFranquiaModel";
import Configuracoes from "@/models/enum/configuracao/configuracoes";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import OrigemEtapa from "@/models/enum/origemEtapa";
import TipoEtapa from "@/models/enum/tipoEtapa";
import EtapaPCPModel from "@/models/pcp/etapaPCPModel";
import EtapaPCPService from "@/services/etapaPCPService";
import setorService from "@/services/setorService";
import { Getters } from "@/store/store";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        checkboxComponent,
        comboComponent,
    },
    computed: {
        ...mapGetters(["GET_CONFIG_FRANQUIA"] as Getters),
    },
})
export default class EtapaEditComponent extends EditComponentBase<EtapaPCPModel> {
    // State computed props
    GET_CONFIG_FRANQUIA: (configuracao: Configuracoes) => ConfiguracaoFranquiaModel;

    private usaControlePcpProducaoBases = false;

    tipoOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(TipoEtapa);
    origemEtapaOptions = [
        { text: "Venda", value: OrigemEtapa.Venda },
        { text: "Produção de bases", value: OrigemEtapa.ProducaoBases },
    ];
    setorOptions = [];

    private async beforeMount() {
        await this.setProps(new EtapaPCPService(), "especie_de_animal", new EtapaPCPModel());

        this.setorOptions = await setorService.comboCached(this.usuarioLogado.franquiaId);
    }

    public async afterMounted() {
        this.usaControlePcpProducaoBases = this.GET_CONFIG_FRANQUIA(
            Configuracoes.UsarControlePcpProducaoBases,
        )?.verdadeiro;
    }
}
